export default "__VITE_ASSET__DeccGxr___"